import React from 'react';
import {OrbitSuspense} from '../../base-components/orbit-suspense/orbit-suspense';
import {RouteDefinition} from '../../../services/routing-configuration/route-definition/route-definition';
import {
    CASINO_GAMES_ARENA_NAME,
    CIP_ALL_GAMES_ARENA_NAME, HOME_PAGE_ARENA, JACKPOTS_ARENA_NAME, NEW_GAMES_ARENA_NAME,
    NEW_LIVE_CASINO_ARENA_NAME, PROGRESSIVE_SLOTS_ARENA_NAME,
    SLOTS_ARENA_NAME, VIDEO_POKER_ARENA_NAME
} from '../../../services/arenas/arena-consts';
import {GamingHistoryType} from "../../../services/gaming-history/gaming-history-type";
import {
    CASINO_GAMES_PAGE, CHALLENGE_PAGE, GAMES_OPEN_SESSIONS_PAGE,
    GAMING_HISTORY_PAGE,
    HOME_PAGE,
    JACKPOTS_PAGE, JACKPOT_BET_GAMING_HISTORY_PAGE, NEW_GAMES_PAGE,
    NEW_LIVE_CASINO_PAGE, PROGRESSIVE_VIDEO_SLOTS_PAGE, SESSION_HISTORY_PAGE,
    SLOTS_PAGE, VIDEO_POKER_PAGE
} from '../../../themes/css-global-classes';
import {MINI_CIP_BASE_ROUTE, MINI_CIS_BASE_ROUTE} from '../../../services/mini-orbit/mini-orbit-consts';
import {LaboratoryShowcase} from "../../laboratory-showcase/laboratory-showcase.component";


const MiniOrbitPageComponent = React.lazy(
    () => import("../mini-orbit-page.component").then(({MiniOrbitPageComponent}) => ({default: MiniOrbitPageComponent}))
);
const MiniOrbitHomePageComponent = React.lazy(
    () => import("../homepage/mini-orbit-homepage.component").then(({MiniOrbitHomePageComponent}) => ({default: MiniOrbitHomePageComponent}))
);
const MiniOrbitArenaHostComponent = React.lazy(
    () => import("../arenas/mini-orbit-arena-host.component").then(({MiniOrbitArenaHostComponent}) => ({default: MiniOrbitArenaHostComponent}))
);
const GamingHistoryComponent = React.lazy(
    () => import("../../gaming-history/gaming-history.component").then(({GamingHistoryComponent}) => ({default: GamingHistoryComponent}))
);

const GamesOpenSessionsPageComponent = React.lazy(
    () => import('../../games-open-sessions/games-open-sessions-page.component').then(({GamesOpenSessionsPageComponent}) => ({default: GamesOpenSessionsPageComponent}))
);

const RichPageComponent = React.lazy(
    () => import('../../rich-page/rich-page.component').then(({RichPageComponent}) => ({default: RichPageComponent}))
);

export const MINI_ORBIT_ROUTING_DEFINITION: Array<RouteDefinition> = [
    {
        paths: [`${MINI_CIP_BASE_ROUTE}`, `${MINI_CIS_BASE_ROUTE}`],
        exact: true,
        data: {arenaType: HOME_PAGE_ARENA},
        cssSelectors: HOME_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitHomePageComponent/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/slots`, `${MINI_CIS_BASE_ROUTE}/slots`],
        exact: true,
        data: {arenaType: SLOTS_ARENA_NAME},
        cssSelectors: SLOTS_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitArenaHostComponent arenaName={SLOTS_ARENA_NAME}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/new-games`, `${MINI_CIS_BASE_ROUTE}/new-games`],
        exact: true,
        data: {arenaType: NEW_GAMES_ARENA_NAME},
        cssSelectors: NEW_GAMES_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitArenaHostComponent arenaName={NEW_GAMES_ARENA_NAME}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/video-poker`, `${MINI_CIS_BASE_ROUTE}/video-poker`],
        exact: true,
        data: {arenaType: VIDEO_POKER_ARENA_NAME},
        cssSelectors: VIDEO_POKER_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitArenaHostComponent arenaName={VIDEO_POKER_ARENA_NAME}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/progressive-video-slots`, `${MINI_CIS_BASE_ROUTE}/progressive-video-slots`],
        exact: true,
        data: {arenaType: PROGRESSIVE_SLOTS_ARENA_NAME},
        cssSelectors: PROGRESSIVE_VIDEO_SLOTS_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitArenaHostComponent arenaName={PROGRESSIVE_SLOTS_ARENA_NAME}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/casino-games`, `${MINI_CIS_BASE_ROUTE}/casino-games`],
        exact: true,
        data: {arenaType: CASINO_GAMES_ARENA_NAME},
        cssSelectors: CASINO_GAMES_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitArenaHostComponent arenaName={CASINO_GAMES_ARENA_NAME}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/jackpots`, `${MINI_CIS_BASE_ROUTE}/jackpots`],
        exact: true,
        data: {arenaType: JACKPOTS_ARENA_NAME},
        cssSelectors: JACKPOTS_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitArenaHostComponent arenaName={JACKPOTS_ARENA_NAME}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/live-casino`, `${MINI_CIS_BASE_ROUTE}/live-casino`],
        exact: true,
        data: {arenaType: NEW_LIVE_CASINO_ARENA_NAME},
        cssSelectors: NEW_LIVE_CASINO_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitArenaHostComponent arenaName={NEW_LIVE_CASINO_ARENA_NAME}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/gaming-history`, `${MINI_CIS_BASE_ROUTE}/gaming-history`],
        exact: true,
        cssSelectors: GAMING_HISTORY_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <GamingHistoryComponent historyType={GamingHistoryType.UserHistory} redirectHomeIfUnauthorized={true} showMoreDetails={true}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/jackpot-bet-history`, `${MINI_CIS_BASE_ROUTE}/jackpot-bet-history`],
        exact: true,
        cssSelectors: JACKPOT_BET_GAMING_HISTORY_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <GamingHistoryComponent historyType={GamingHistoryType.JackpotBetsGamingHistory} redirectHomeIfUnauthorized={true} showMoreDetails={false}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/session-history`, `${MINI_CIS_BASE_ROUTE}/session-history`],
        exact: true,
        cssSelectors: SESSION_HISTORY_PAGE,
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <GamingHistoryComponent historyType={GamingHistoryType.SessionHistory} redirectHomeIfUnauthorized={true}  showMoreDetails={true}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/open-bets`, `${MINI_CIS_BASE_ROUTE}/open-bets`],
        exact: true,
        cssSelectors: GAMES_OPEN_SESSIONS_PAGE,
        render: () => <OrbitSuspense key={GAMES_OPEN_SESSIONS_PAGE}>
            <MiniOrbitPageComponent content={
                <GamesOpenSessionsPageComponent />
            }/>

        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/cipallgames`, `${MINI_CIS_BASE_ROUTE}/cipallgames`],
        exact: true,
        data: {arenaType: CIP_ALL_GAMES_ARENA_NAME},
        render: () => <OrbitSuspense>
            <MiniOrbitPageComponent content={<OrbitSuspense>
                <MiniOrbitArenaHostComponent arenaName={CIP_ALL_GAMES_ARENA_NAME}/>
            </OrbitSuspense>} />
        </OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/challenge`, `${MINI_CIS_BASE_ROUTE}/challenge`],
        exact: true,
        cssSelectors: CHALLENGE_PAGE,
        render: () => <OrbitSuspense><RichPageComponent/></OrbitSuspense>
    },
    {
        paths: [`${MINI_CIP_BASE_ROUTE}/laboratory`, `${MINI_CIS_BASE_ROUTE}/laboratory`],
        exact: true,
        render: () => <OrbitSuspense><LaboratoryShowcase /></OrbitSuspense>
    },
];